import { render, staticRenderFns } from "./HomeLogo.vue?vue&type=template&id=13c056ea&"
import script from "./HomeLogo.vue?vue&type=script&lang=js&"
export * from "./HomeLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarTitle } from 'vuetify/lib/components/VAppBar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAppBarTitle,VImg})
